const React = require("react")
const Provider = require("./src/provider").default
require("./src/css/index.scss")

exports.wrapRootElement = ({ element }) => {
  return <Provider>{element}</Provider>
}
